import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
   type?: string;
   icon?:string;
	badgeType?: string;
	badgeValue?: string;
   active?: boolean;
   megaMenu?: boolean;
   megaMenuType?: string; // small, medium, large
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
  providedIn: 'root'
})
export class NavService {

  constructor() {   }

  MENUITEMS: Menu[] = [
	 {
			title: 'Home', type: 'link', path: 'home',
    },
    {
      title: 'The Team', type: 'link', path: 'team'
    },
    {
         title: 'About Us', type: 'link', path: 'about'
    },
    {
         title: 'Services', type: 'link', path: 'services'
    },
    {
         title: 'Testimonials', type: 'link', path: 'testimonials'
    },
    {
         title: 'Appointments', type: 'link', path: 'appointments'
    },
    {
         title: 'Legal documents', type: 'link', path: 'legal'
    },
    {
         title: 'Contact Us', type: 'link', path: 'contact-us'
    }

   ]

  	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

}
